import { useLocation } from "../hooks/useLocation.js";
import { ImageThumbnail } from "../../../components/ImageThumbnail/index.js";
import { useAppInteractionHandlers } from "../../AppWrapper2/hooks/useAppInteractionHandlers.js";
import { useMemo } from "react";
import { Card, Skeleton } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { formatAddress } from "@therms/web-js";
import classnames from "classnames";
//#region src/modules/Locations/shared/LocationCard.tsx
var LocationCard = ({ location, locationId, onClick }) => {
	const appInteractionHandlers = useAppInteractionHandlers();
	const { data, loading } = useLocation(locationId && { locationId });
	const { active, address, id, name, primaryImageUrl } = useMemo(() => {
		if (data?.location) return data.location;
		else if (location) return location;
		else return {};
	}, [location, data]);
	const _locationId = locationId || id;
	const isClickable = active && !!(_locationId && onClick || appInteractionHandlers?.onClickLocation);
	return /* @__PURE__ */ jsx(Card, {
		className: classnames("bg-surface-subtle relative overflow-hidden", { "cursor-pointer": isClickable }),
		onClick: isClickable ? () => {
			if (onClick) onClick();
			else if (_locationId) appInteractionHandlers?.onClickLocation?.(_locationId);
		} : void 0,
		space: "xxs",
		padding: "xs",
		children: loading ? /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsxs("div", {
			className: "w-full",
			children: [/* @__PURE__ */ jsx(Skeleton.Text, {}), /* @__PURE__ */ jsx(Skeleton.Text, {})]
		}) }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
			className: classnames({ "opacity-50": !active }, "flex w-full items-center"),
			children: [/* @__PURE__ */ jsx("div", {
				className: "mr-xs shrink-0",
				children: /* @__PURE__ */ jsx(ImageThumbnail, { src: primaryImageUrl })
			}), /* @__PURE__ */ jsxs("div", {
				className: "grow",
				children: [/* @__PURE__ */ jsx("div", {
					className: "text-color-strong flex justify-between",
					children: /* @__PURE__ */ jsx("span", { children: name })
				}), /* @__PURE__ */ jsx("div", {
					className: "font-light whitespace-pre-wrap",
					children: formatAddress(address, true) || " "
				})]
			})]
		}), !active && /* @__PURE__ */ jsx("div", {
			className: "z-sticky bg-critical/10 text-color-critical p-sm absolute inset-0 flex items-center justify-center rounded font-bold tracking-wider",
			children: "INACTIVE"
		})] })
	});
};
//#endregion
export { LocationCard };

//# sourceMappingURL=LocationCard.js.map